import { useLayoutEffect } from 'react';

import { useStore } from '@/store/useStore';

const WRAPPER_ID = 'game-launcher-wrapper';

export const useNativeSafeZonePadding = (): void => {
  const safeZone = useStore((s) => s.deviceSafeZone.safeZone);

  useLayoutEffect(() => {
    const wrapper = document.getElementById(WRAPPER_ID);
    if (!wrapper) {
      return;
    }

    if (!safeZone) {
      wrapper.style.padding = '';
      return;
    }

    wrapper.style.padding = `${safeZone.top}px ${safeZone.right}px ${safeZone.bottom}px ${safeZone.left}px`;
  }, [safeZone]);
};
